import { API_ROUTE_ADMIN_REPORTS_CUSTOMERS } from '@/resources/api-routes'
import { get } from '@/util/auth'

type ReportCustomerOriginal = {
  id: number
  name: string
}
const IS_NEW_BACKEND_API = true

export const getReportCustomers = async () => {
  const reports = await get<ReportCustomerOriginal[]>(
    API_ROUTE_ADMIN_REPORTS_CUSTOMERS,
    IS_NEW_BACKEND_API
  )

  return reports
}
